// S-L10: Line of Credit API Endpoints
import { apiClient } from './client';

export interface CreditLine {
  id: string;
  status: 'inactive' | 'active' | 'frozen' | 'closed';
  terms_status: 'not_eligible' | 'eligible' | 'accepted';
  credit_limit_cents: number;
  outstanding_balance_cents: number;
  available_credit_cents: number;
  current_apr_bps: number | null;
  ytd_interest_cents: number;
  terms_accepted_at: string | null;
  opened_at: string | null;
  closed_at: string | null;
}

export interface CreditLineEligibility {
  eligible: boolean;
  reasons: string[];
  base_principal_cents: number;
  initial_principal_cents: number;
  threshold_cents: number;
  progress_percent: number;
}

export interface DrawRequest {
  id: string;
  requested_amount_cents: number;
  status: 'requested' | 'approved' | 'rejected' | 'paid_off_platform' | 'canceled';
  requested_at: string;
  reviewed_at: string | null;
  admin_note: string | null;
  reject_reason: string | null;
}

export interface CreditLineResponse {
  credit_line: CreditLine | null;
  pending_draw_request: DrawRequest | null;
}

export interface EligibilityResponse {
  eligibility: CreditLineEligibility;
}

export interface DrawRequestsResponse {
  draw_requests: DrawRequest[];
  page: number;
  per_page: number;
  total: number;
}

export interface CreateDrawRequestParams {
  requested_amount_cents: number;
}

export interface CreateDrawRequestResponse {
  success: boolean;
  draw_request: DrawRequest;
  message: string;
}

export interface AcceptTermsResponse {
  success: boolean;
  credit_line: CreditLine;
  message: string;
}

export const creditLineEndpoints = {
  // GET /api/me/credit_line
  getCreditLine: async (): Promise<CreditLineResponse> => {
    return await apiClient.get('/api/me/credit_line');
  },

  // GET /api/me/credit_line/eligibility
  getEligibility: async (): Promise<EligibilityResponse> => {
    return await apiClient.get('/api/me/credit_line/eligibility');
  },

  // GET /api/me/credit_line/draw_requests
  getDrawRequests: async (status?: string): Promise<DrawRequestsResponse> => {
    const params = new URLSearchParams();
    if (status) params.append('status', status);
    
    const queryString = params.toString();
    const url = `/api/me/credit_line/draw_requests${queryString ? `?${queryString}` : ''}`;
    
    return await apiClient.get(url);
  },

  // POST /api/me/credit_line/draw_requests
  createDrawRequest: async (params: CreateDrawRequestParams): Promise<CreateDrawRequestResponse> => {
    return await apiClient.post('/api/me/credit_line/draw_requests', params);
  },

  // POST /api/me/credit_line/accept_terms
  acceptTerms: async (): Promise<AcceptTermsResponse> => {
    return await apiClient.post('/api/me/credit_line/accept_terms');
  },
};
